import type { MyWeekDefaultShift } from '../../models/my-week.model';
import type { EMPLOYMENT_ERROR_CODES, EmploymentDetails, EmploymentRow, EmploymentWeekdayPlanning, IsoWeekday } from './employment.model';

export const EMPLOYMENT_PLANNING_PORT = 'EMPLOYMENT_PLANNING_PORT' as const;

export interface EmploymentPlanningIssue {
  code: (typeof EMPLOYMENT_ERROR_CODES)['defaultShiftInvalid' | 'defaultShiftOverlap'];
  periodKey: string;
  weekday: IsoWeekday;
  shiftUnitId: string;
}

export interface EmploymentPlanningPort {
  enrich(periodIds: readonly string[], tx: unknown): Promise<Map<string, Map<IsoWeekday, EmploymentWeekdayPlanning>>>;
  validate(
    personId: string,
    rows: ReadonlyArray<{ key: string; row: EmploymentRow; details?: EmploymentDetails }>,
    tx: unknown
  ): Promise<{ issues: EmploymentPlanningIssue[]; changed: boolean }>;
  apply(personId: string, rows: ReadonlyArray<{ row: EmploymentRow; details?: EmploymentDetails }>, tx: unknown): Promise<void>;
  defaultWorkingDays(personId: string, tx: unknown): Promise<IsoWeekday[] | null>;
  resolveDefaultShifts(
    personIds: readonly string[],
    from: string,
    to: string,
    tx?: unknown
  ): Promise<Map<string, Map<string, MyWeekDefaultShift[]>>>;
}

export const EMPLOYMENT_SCHEDULE_READER = 'EMPLOYMENT_SCHEDULE_READER' as const;

export interface EmploymentScheduleReader {
  loadRows(personIds: readonly string[], from: string | null, to: string | null, tx?: unknown): Promise<Map<string, EmploymentRow[]>>;
}
